<template>
  <div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'onBoard',
  components: {
  }
}
</script>
<style lang="less" scoped>
</style>

